import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainMenuComponent } from './mainMenu.component';
import { FollowupVisitComponent } from './followupVisit/followupVisit.component';
import { UnverifiedComplaintComponent } from './unverifiedComplaint/unverifiedComplaint.component';
import { ComplaintResponseComponent } from './complaintResponse/complaintResponse.component';
import { BusinessResponseComponent } from './businessResponse/businessResponse.component';
import { SiteVisitComponent } from './siteVisit/siteVisit.component';
import { PostRemediationComponent } from './postRemediation/postRemediation.component';
import { CitationsComponent } from './citations/citations.component';
import { AnnualInspectionsComponent } from './annualInspections/annualInspections.component';
import { EnclosedAreasComponent } from './enclosedAreas/enclosedAreas.component';
import { WelcomeComponent } from '../welcome/welcome.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { AssociateBusinessComponent } from './unverifiedComplaint/associateBusiness/associateBusiness.component';
// import { HelpFileComponent } from './help/help.component';



const routes: Routes = [
  { path: 'MainMenu', component: MainMenuComponent, canActivate: [ AuthGuard ] },
  { path: '', component: MainMenuComponent, canActivate: [ AuthGuard ] },
  { path: 'FollowupVisit', component: FollowupVisitComponent, canActivate: [ AuthGuard ] },
  { path: 'UnverifiedComplaint', component: UnverifiedComplaintComponent, canActivate: [ AuthGuard ] },
  { path: 'ComplaintResponse', component: ComplaintResponseComponent, canActivate: [ AuthGuard ] },
  { path: 'BusinessResponse', component: BusinessResponseComponent, canActivate: [ AuthGuard ] },
  { path: 'SiteVisit', component: SiteVisitComponent, canActivate: [ AuthGuard ] },
  { path: 'PostRemediation', component: PostRemediationComponent, canActivate: [ AuthGuard ] },
  { path: 'Citations', component: CitationsComponent, canActivate: [ AuthGuard ] },
  { path: 'AnnualInspections', component: AnnualInspectionsComponent, canActivate: [ AuthGuard ] },
  { path: 'EnclosedAreas', component: EnclosedAreasComponent, canActivate: [ AuthGuard ] },
  { path: 'Welcome', component: WelcomeComponent, canActivate: [ AuthGuard ] },
  { path: 'AssociateBusiness', component: AssociateBusinessComponent, canActivate: [ AuthGuard ] },
  // { path: 'help', component: HelpFileComponent, canActivate: [ AuthGuard ] },
  { path: '**', component: MainMenuComponent, canActivate: [ AuthGuard ] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [
  ]
})
export class MainMenuRoutingModule { }
